<template>
  <el-row class="el-row-slider">
    <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
      <el-menu :default-active="activeId"
               class="el-menu-vertical-demo"
               @open="handleOpen"
               @close="handleClose"
               @select="handleClick"
               background-color="#001f3f"
               active-background-color="rgb(52, 53, 53)"
               text-color="#fff"
               :collapse="isCollapse">

        <el-menu-item style="text-align: center;line-height: 60px;color: white">
          <span style="font-size: 3em; color: #ffe31e;font-weight: bold">ZGEO</span>

        </el-menu-item>
        <template v-for="(item,index) in menu.child" v-if="item.visible">
          <el-submenu  v-if="item.child&&item.child.length>0" :index="index+''">
            <template slot="title">
              <i :class="item.iconcls"></i>
              <span>{{item.name}}</span>
            </template>
            <el-menu-item v-for="(child,x) in item.child" :index="index+'-'+x" :key="child.path" v-if="!child.hidden">
              <!--<i :class="child.iconCls"></i>-->
              <span>{{child.name}}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-if="!item.child" :index="index+''">
            <i :class="item.iconcls"></i>
            <span>{{item.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-col>
  </el-row>

</template>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

  .el-menu {
    border-right: none !important;
    height: 100%;
  }

  .el-row-slider {
    background-color: #001f3f;
  }
</style>

<script>
  import trans from '../transform/trans'
  import {getShareList} from '../services/shareService'
  import {toLowerCase} from "../transform/httpAjax";

  export default {
    data() {
      return {
        href:'',
        activeId:'0',
        shareClassList: null,
        isCollapse: false,
        menu: {
          "name": "公共资源库",
          "child": []
        },
      };
    },
    created: function () {
      var self = this;
      if(!this.href){
        this.href= window.location.origin+window.location.pathname+"#/";
      }
      getShareList()
        .then(function (res) {
          console.log(res)
          var list = toLowerCase(res.data.list), rs = {}, dts = [];
          for (var i = 0, length = list.length; i < length; i++) {

            if (list[i].class === '1') {
              self.menu.child.push(list[i]);
              if (list[i].child) {
                var json = {
                  name: list[i]['child'],
                  child: []
                };
                list[i]['child'] = json['child'];

                dts.push(json);
              }
            } else {
              for (var w in dts) {
                if (dts[w]['name'].indexOf(list[i].title) > -1) {
                  dts[w]['child'].push(list[i]);
                }
              }
            }
          }
         var keyPath= window.location.href.split("?");
          console.log(keyPath);
          if(keyPath.length===2){
           setTimeout(function () {
             self.handleClick(keyPath[1],"");
             self.activeId=keyPath[1]
           },1000)
          }

        })
        .catch(res => {
          console.log(res, 123)
        });

      trans.$on('collapse-slider', (data) => {
        this.isCollapse = data;
      });
    },
    methods: {
      handleOpen(key, keyPath) {
      },
      handleClose(key, keyPath) {
      },
      handleClick(key, keyPath) {
        var menus = this.menu;
        let keys=key.split("-");
        window.location.href =this.href+ "?"+key;

        trans.$emit('select-slider', keys.length === 2 ? menus.child[keys[0]].child[keys[1]] : menus.child[keys[0]]);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/slider.vue